import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const Faq = () => {
  const { t } = useTranslation();
  return (
    <>
      <div className="faq-area ptb-100 pt-0">
        <div className="container">
          <div
            className="saas-section-title"
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-once="true"
            data-aos-delay="100"
          >
            <h2>{t("static.faq.title")}</h2>
            <div className="bar"></div>
            {/* <p>
              Quis ipsum suspendisse ultrices gravida. Risus commodo viverra
              maecenas accumsan lacus vel facilisis.
            </p> */}
          </div>

          <div
            className="faq"
            data-aos="fade-up"
            data-aos-duration="800"
            data-aos-once="true"
            data-aos-delay="200"
          >
            <Accordion preExpanded={["a"]}>
              <AccordionItem uuid="a">
                <AccordionItemHeading>
                  <AccordionItemButton>
                    {t("static.faq.question1")}
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    {t("static.faq.response1")}
                  </p>
                </AccordionItemPanel>
              </AccordionItem>

              <AccordionItem uuid="b">
                <AccordionItemHeading>
                  <AccordionItemButton>
                    {t("static.faq.question2")}
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    {t("static.faq.response2")}
                  </p>
                </AccordionItemPanel>
              </AccordionItem>

              <AccordionItem uuid="c">
                <AccordionItemHeading>
                  <AccordionItemButton>
                    {t("static.faq.question3")}
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    {t("static.faq.response3")}
                  </p>
                </AccordionItemPanel>
              </AccordionItem>

              <AccordionItem uuid="ad">
                <AccordionItemHeading>
                  <AccordionItemButton>
                    {t("static.faq.question4")}
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    {t("static.faq.response4")}
                  </p>
                </AccordionItemPanel>
              </AccordionItem>

              <AccordionItem uuid="e">
                <AccordionItemHeading>
                  <AccordionItemButton>
                    {t("static.faq.question5")}
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    {t("static.faq.response5")}
                  </p>
                </AccordionItemPanel>
              </AccordionItem>

              <AccordionItem uuid="qq">
                <AccordionItemHeading>
                  <AccordionItemButton>
                    {t("static.faq.question6")}
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    {t("static.faq.response6")}
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem uuid="qwe">
                <AccordionItemHeading>
                  <AccordionItemButton>
                    {t("static.faq.question7")}
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                     {t("static.faq.response7")}
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem uuid="qwr">
                <AccordionItemHeading>
                  <AccordionItemButton>
                    {t("static.faq.question8")}
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    {t("static.faq.response8")}
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem uuid="wer">
                <AccordionItemHeading>
                  <AccordionItemButton>
                    {t("static.faq.question9")}
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    {t("static.faq.response9")}
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
              <AccordionItem uuid="ertt">
                <AccordionItemHeading>
                  <AccordionItemButton>
                    {t("static.faq.question10")}
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <p>
                    {t("static.faq.response10")}
                  </p>
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </div>
    </>
  );
};

export default Faq;
